<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Question</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CSelect label="Topic" :options="topics" :value.sync="question.topic_id" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="Bangla" v-model="question.bangla" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea label="English" v-model="question.english" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect label="Type" :options="types" :value.sync="question.type" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <img v-if="question.type==='image'" :src="media_url" style="width: 200px; height: 200px;">
          <video v-if="question.type==='video'" width="320" height="240" controls>
            <source :src="media_url" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          <audio v-if="question.type==='audio'" controls>
            <source :src="media_url" type="audio/mpeg">
            Your browser does not support the audio tag.
          </audio>
          <div v-if="question.type!=='text'">
            <CInputFile
                    label="Media attachment"
                    vertical
                    ref="file"
                    type="file" id="file"
                    @change="onImageChange"
                    style="width: 200px"
            />
            <label class="text-danger">(Image Size should be (360 X 360) and less than 1 MB)</label>
            <progress max="100" :value.prop="upload_percentage" v-if="upload_percentage>0"></progress>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol col="12"><h3 class="font-weight-bold">Options</h3></CCol>
          <CCol sm="12">
            <CSelect label="Options Type" :options="types" :value.sync="question.answer_type" />
          </CCol>
        <CCol sm="12" md="6" v-for="(option,i) in options">
          <div class="d-flex" v-if="question.answer_type==='text'">
            <input type="radio" v-model="question.answer_id" :value="option.id">
            <CInput :label="i+1 +' bangla'" v-model="option.bangla"></CInput>
            <CInput label="english" v-model="option.english"></CInput>
          </div>
          <div v-else-if="question.answer_type==='image'">
            <input type="radio" v-model="question.answer_id" :value="option.id">
            <img :src="option.media_url" style="width: 100px; height: 100px; margin: 0.5rem">
            <CInputFile
                    vertical
                    ref="file"
                    type="file"
                    @change="onOptionImageChange($event,i)"
                    style="width: 200px;"
            />
              <button class="btn btn-success ml-3" v-if="option.upload_btn" @click="uploadOptionImage(option.id,i)" >Upload</button>

          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" v-if="$store.state.auth.user_permissions.includes('question approve')">
          <div class="h5 font-weight-bold" :class="[question.approved ? 'text-success' : 'text-danger']">
            <input class="m-1" type="checkbox" v-model="question.approved" />Approved
          </div>
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Question
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "QuestionEdit",
  data() {
    return {
      question: {},
      options: [],
      topics: [],
      media_url: "",
      types: ["text", "audio", "video", "image"],
      selectedTopic: 1,
      upload_percentage: 0
    };
  },
  created() {
    this.getTopics();
    this.getQuestion();
  },
  methods: {
    getTopics() {
      this.$axios
        .get(`${ADMIN_URL}/topics/`)
        .then((response) => {
          console.log(response.data);
          response.data.topic_list.forEach((e) => {
            this.topics.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getQuestion() {
      this.$axios
        .get(`${ADMIN_URL}/questions/${this.$route.params.id}`)
        .then((response) => {
          console.log("categories, response === ", response.data);
          this.question = response.data.question
          this.media_url = ROOT_URL + '/' + this.question.url
          this.options =  response.data.question.options.map(el => {
            let o = Object.assign({}, el);
            o.media_url = ROOT_URL + '/'+ el.url;
            o.upload_btn = false
            return o;
          })
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.question.url = file;
      this.media_url = URL.createObjectURL(file);
    },
    onOptionImageChange(e,i) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.options[i].url = file;
      this.options[i].media_url = URL.createObjectURL(file);
      this.options[i].upload_btn = true
    },
    uploadOptionImage(id,i) {
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        }};
      let selected_option = this.options.find(o =>{
        return o.id === id
      })
      this.options[i].upload_btn = false
      console.log('s',selected_option)
      let formData = new FormData();
      formData.append("id", id);
      formData.append("attachment", selected_option.url);
      this.$axios
              .post(`${ADMIN_URL}/options/update-image`, formData, config)
              .then((response) => {
                console.log("Success", response);
                currentObj.success = response.data.success;
                console.log(response.data);
                this.$swal("Success", response.data.message, "success");
              })
              .catch((error) => {
                console.log("Error  ... ", error.response);
                currentObj.output = error;
                this.$swal("Error", error.response.message, "error");
              });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
        onUploadProgress: function( progressEvent ) {
          this.upload_percentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
        }.bind(this)
      };

      let formData = new FormData();
      formData.append("bangla", this.question.bangla);
      formData.append("english", this.question.english);
      formData.append("type", this.question.type);
      formData.append("answer_type", this.question.answer_type);
      formData.append("attachment", this.question.url);
      formData.append("topic_id", this.question.topic_id);
      formData.append("answer_id", this.question.answer_id);
      formData.append("options", JSON.stringify(this.options));
      formData.append("approved", this.question.approved);
      formData.append("_method", "put");

      this.$axios
        .post(`${ADMIN_URL}/questions/${this.$route.params.id}`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
         // window.location.reload();
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
  },
};
</script>

<style scoped>
</style>
